import {
    ADMIN_LOGIN_ROUTE,
    ADMIN_PROFILE_ROUTE,
    CART_ROUTE,
    CHECKOUT_ROUTE,
    CONTACT_ROUTE,
    CUSTOMER_PROFILE_ROUTE,
    MAIN_ROUTE,
    ROLES,
    TERMS_ROUTE,
    NOUVEAUTES_ROUTE,
    ARRIVES_ROUTE
} from "@/utils/constants.js";
import HomeContainer from "@/pages/home/HomeContainer.jsx";
import NouveautesPage from "@/pages/catalog-section/NouveautesPage.jsx";
import ArrivesPage from "@/pages/catalog-section/ArrivesPage.jsx";
import ProductPage from "@/pages/product/ProductPage.jsx";
import CartPage from "@/pages/cart/CartPage.jsx";
import CheckoutPage from "@/pages/cart/CheckoutPage.jsx";
import CustomerProfile from "@/pages/customer-profile/CustomerProfile.jsx";
import OrderDetailPage from "@/pages/customer-profile/OrderDetailPage.jsx";
import AdminProfile from "@/pages/admin-profile/AdminProfile.jsx";
import AdminLoginPage from "@/pages/admin-login/AdminLoginPage.jsx";
import ContactPage from "@/pages/contact/ContactPage.jsx";
import TermsPage from "@/pages/legal/TermsPage.jsx";

export const publicRoutes = [
    { path: MAIN_ROUTE, Component: HomeContainer },
    { path: NOUVEAUTES_ROUTE, Component: NouveautesPage },
    { path: ARRIVES_ROUTE, Component: ArrivesPage },
    { path: ADMIN_LOGIN_ROUTE, Component: AdminLoginPage },
    { path: CONTACT_ROUTE, Component: ContactPage },
    { path: TERMS_ROUTE, Component: TermsPage }
];

export const authRoutes = [
    { path: CUSTOMER_PROFILE_ROUTE, Component: CustomerProfile, roles: [ROLES.CUSTOMER] },
    { path: CART_ROUTE, Component: CartPage, roles: [ROLES.CUSTOMER] },
    { path: CHECKOUT_ROUTE, Component: CheckoutPage, roles: [ROLES.CUSTOMER] },
    { path: ADMIN_PROFILE_ROUTE, Component: AdminProfile, roles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.SECRETARY] }
];

export { ProductPage, OrderDetailPage };
